type Props = {
  title: string;
  subTitle?: string;
  end?: JSX.Element;
};

export function EPageTitle({ title, subTitle, end }: Props) {
  return (
    <div className="md:flex md:justify-between mt-2 mb-6">
      <div className="flex-1 mb-4 md:mb-0">
        <div className="text-2xl font-bold tracking-tight text-slate-800 capitalize">
          {title}
        </div>
        <p className="text-sm text-slate-500 font-medium">{subTitle}</p>
      </div>
      {end ? <div className="right">{end}</div> : null}
    </div>
  );
}
